module.exports = __webpack_public_path__ + "static/media/help-img4.73b32d4d.png";